import { send } from '@/framework/logic';

export default function createForwardActionsMiddleware({ match }) {
  return () => {
    return next => action => {
      const result = next(action);
      if (match(action)) {
        send(action);
      }
      return result;
    };
  };
}
